import styled from '@emotion/styled';

export const Container = styled.div``;

export const NameContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const ResultHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 0.25rem;
`;
